import axios from 'axios';
import errorResponseHandler from '../ErrorHandler/errorHandler';

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
  withCredentials: true,
  headers: {
    'Accept-Version': 1,
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  }
});

AxiosInstance.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem('NewQRadar_accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },

);

// apply interceptor on response
AxiosInstance.interceptors.response.use(
  response => response,
  errorResponseHandler
);

export default AxiosInstance;
